import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton";
import styles from "./Introduction.module.scss";

const Introduction = () => {
  const data = [
    {
      loanType: "Short-Term Loan",
      purpose: "Immediate cash flow needs or urgent expenses.",
      loadAmount: "$1,000 - $20,000",
      termLength: "1 - 6 months",
    },
    {
      loanType: "Long-Term Loan",
      purpose: "Business expansion, major capital investments, or significant upgrades.",
      loadAmount: "$20,000 - $200,000",
      termLength: "18 - 36 months",
    },
    {
      loanType: "Working Capital Loan",
      purpose: "Day-to-day operational expenses and cash flow management.",
      loadAmount: "$5,000 - $50,000",
      termLength: "3 - 12 months",
    },
  ];

  const columns = [
    { name: "Loan Type", selector: (row) => row.loanType, grow: 1, minWidth: "140px" },
    { name: "Purpose", selector: (row) => row.purpose, grow: 3, minWidth: "200px" },
    { name: "Loan Amount", selector: (row) => row.loadAmount, grow: 1, minWidth: "160px" },
    { name: "Term Length", selector: (row) => row.termLength, grow: 1, minWidth: "140px" },
  ];

  return (
    <section className={styles.mainIntroductionContainer}>
      <div className={styles.header}>
        Welcome to Maelano Seller Financing. At Maelano, we understand the
        financial needs of our sellers. Whether you are looking to expand your
        inventory, invest in marketing, or manage cash flow, our Seller
        Financing options are here to help you achieve your business goals.
      </div>

      <div className={styles.sectionHeading}>Key Benefits</div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsWrapper}>
          <ul className="mb-0">
            <li>
              Quick and Easy Application Process: Apply online with minimal
              paperwork.
            </li>
            <li>
              Flexible Loan Amounts: Choose the loan amount that fits your
              needs.
            </li>
            <li>
              Competitive Interest Rates: Benefit from our competitive rates and
              favorable terms.
            </li>
            <li>Fast Approval: Get approval within days, not weeks.</li>
            <li>
              No Hidden Fees: Transparent fee structure with no surprises.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.sectionHeading}>Step-by-Step Process</div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsWrapper}>
          <ul className="mb-0">
            <li>
              Submit Your Application: Complete our simple online application
              form with your business details and loan requirements.
            </li>
            <li>
              Application Review: Our team will review your application and may
              request additional documents if necessary.
            </li>
            <li>
              Approval and Agreement: Once approved, you will receive a loan
              agreement outlining the terms and conditions.
            </li>
            <li>
              Receive Funds: Funds will be disbursed directly to your account,
              ready for you to use.
            </li>
            <li>
              Repayment: Repay the loan through easy, scheduled payments as per
              the agreement.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.sectionHeading}>Eligibility Criteria</div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsWrapper}>
          <ul className="mb-0">
            <li>
              Registered Maelano Seller: You must be a registered seller on our
              platform.
            </li>
            <li>
              Business Tenure: Your business should be operational for a minimum
              period (e.g., 6 months).
            </li>
            <li>
              Sales Performance: Demonstrate consistent sales performance on the
              Maelano platform.
            </li>
            <li>
              Creditworthiness: Maintain a good credit history and financial
              standing.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.sectionHeading}>Required Documents</div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsWrapper}>
          <ul className="mb-0">
            <li>
              Quick and Easy Application Process: Apply online with minimal
              paperwork.
            </li>
            <li>Business Registration Certificate</li>
            <li>Bank Statements (Last 6 months)</li>
            <li>Financial Statements</li>
            <li>Tax Identification Number (TIN)</li>
            <li>Loan Agreement (Signed)</li>
          </ul>
        </div>
      </div>

      <div className={styles.sectionHeading}>Loan Type</div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsWrapper}>
          <div className="mb-3">Following is the FBM pricing structure</div>
          <DatatableComponent columns={columns} data={data} type={"gray"} />
        </div>
      </div>

      <div className="d-flex justify-content-center mb-3">
        <PrimaryButton name={"Apply for Financing"} />
      </div>
    </section>
  );
};

export default Introduction;